/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Library_Sorts_XpInputs */

const id_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const ms_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const da_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const de_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const en_us2_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const es_es2_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const es_mx2_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const fil_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const fr_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const it_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const hu_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const nl_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const no_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const pl_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const pt_br2_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const pt_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const ro_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const fi_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const sv_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const vi_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const tr_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const cs_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const bg_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const ru_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опыт (XP)`)
};

const uk_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const ar_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const hi_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const th_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const ja_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const zh_cn2_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`经验值`)
};

const zh_hant1_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`經驗值`)
};

const ko_profile_library_sorts_xp = /** @type {(inputs: Profile_Library_Sorts_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

/**
* | output |
* | --- |
* | "XP" |
*
* @param {Profile_Library_Sorts_XpInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_library_sorts_xp = /** @type {((inputs?: Profile_Library_Sorts_XpInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Library_Sorts_XpInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_library_sorts_xp(inputs)
	if (locale === "ms") return ms_profile_library_sorts_xp(inputs)
	if (locale === "da") return da_profile_library_sorts_xp(inputs)
	if (locale === "de") return de_profile_library_sorts_xp(inputs)
	if (locale === "en-US") return en_us2_profile_library_sorts_xp(inputs)
	if (locale === "es-ES") return es_es2_profile_library_sorts_xp(inputs)
	if (locale === "es-MX") return es_mx2_profile_library_sorts_xp(inputs)
	if (locale === "fil") return fil_profile_library_sorts_xp(inputs)
	if (locale === "fr") return fr_profile_library_sorts_xp(inputs)
	if (locale === "it") return it_profile_library_sorts_xp(inputs)
	if (locale === "hu") return hu_profile_library_sorts_xp(inputs)
	if (locale === "nl") return nl_profile_library_sorts_xp(inputs)
	if (locale === "no") return no_profile_library_sorts_xp(inputs)
	if (locale === "pl") return pl_profile_library_sorts_xp(inputs)
	if (locale === "pt-BR") return pt_br2_profile_library_sorts_xp(inputs)
	if (locale === "pt") return pt_profile_library_sorts_xp(inputs)
	if (locale === "ro") return ro_profile_library_sorts_xp(inputs)
	if (locale === "fi") return fi_profile_library_sorts_xp(inputs)
	if (locale === "sv") return sv_profile_library_sorts_xp(inputs)
	if (locale === "vi") return vi_profile_library_sorts_xp(inputs)
	if (locale === "tr") return tr_profile_library_sorts_xp(inputs)
	if (locale === "cs") return cs_profile_library_sorts_xp(inputs)
	if (locale === "bg") return bg_profile_library_sorts_xp(inputs)
	if (locale === "ru") return ru_profile_library_sorts_xp(inputs)
	if (locale === "uk") return uk_profile_library_sorts_xp(inputs)
	if (locale === "ar") return ar_profile_library_sorts_xp(inputs)
	if (locale === "hi") return hi_profile_library_sorts_xp(inputs)
	if (locale === "th") return th_profile_library_sorts_xp(inputs)
	if (locale === "ja") return ja_profile_library_sorts_xp(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_library_sorts_xp(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_library_sorts_xp(inputs)
	return ko_profile_library_sorts_xp(inputs)
});
export { profile_library_sorts_xp as "profile.library.sorts.xp" }